const externalUrls = [
  {
    title: "Governance (Soon)",
    url: "https://app.gws.finance/",
    icon: <i className="fa-light fa-hexagon"></i>,
    disabled: true
  },
  {
    title: "Docs",
    url: "https://generational-wealth-society.gitbook.io/generational-wealth-society/",
    icon: <i className="fa-light fa-layer-group"></i>,
    disabled: false
  },
  {
    title: "Feedback",
    url: "mailto:contact@gws.finance",
    icon: <i className="fa-light fa-heart"></i>,
    disabled: false
  },
];

export default externalUrls;
